"use strict";

exports.__esModule = true;
exports.default = exports.Layout = exports.LayoutContent = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("@formatjs/intl-relativetimeformat/polyfill");

var _Provider = _interopRequireDefault(require("../../providers/Locale/Provider"));

var _react = _interopRequireWildcard(require("react"));

var _intlLocalesSupported = _interopRequireDefault(require("intl-locales-supported"));

var _intl = _interopRequireDefault(require("intl"));

var _reactIntl = require("react-intl");

var _reactRouterDom = require("react-router-dom");

var _locale = require("../../utils/locale");

var _Config = require("../../providers/Config");

var _Locale = require("../../providers/Locale");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

const loadLocalePolyfill = locale => {
  // START: Intl polyfill
  // Required for working on Safari
  // Code from here: https://formatjs.io/guides/runtime-environments/
  let localesMyAppSupports = [locale];

  if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!(0, _intlLocalesSupported.default)(localesMyAppSupports)) {
      // `Intl` exists, but it doesn't have the data we need, so load the
      // polyfill and replace the constructors with need with the polyfill's.
      let IntlPolyfill = _intl.default;
      Intl.NumberFormat = IntlPolyfill.NumberFormat;
      Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
  } else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = _intl.default;
  } // END: Intl polyfill

};

const LayoutContent = () => {
  const _useState = (0, _react.useState)([]),
        messages = _useState[0],
        setMessages = _useState[1];

  const _useConfig = (0, _Config.useConfig)(),
        appConfig = _useConfig.appConfig;

  const _ref = appConfig || {},
        components = _ref.components,
        _ref$routes = _ref.routes,
        routes = _ref$routes === void 0 ? [] : _ref$routes,
        containers = _ref.containers,
        confLocale = _ref.locale,
        getDefaultRoutes = _ref.getDefaultRoutes;

  const _ref2 = components || {},
        Menu = _ref2.Menu,
        Loading = _ref2.Loading;

  const _ref3 = confLocale || {},
        locales = _ref3.locales,
        onError = _ref3.onError;

  const _ref4 = containers || {},
        _ref4$LayoutContainer = _ref4.LayoutContainer,
        LayoutContainer = _ref4$LayoutContainer === void 0 ? _react.default.Fragment : _ref4$LayoutContainer;

  const defaultRoutes = getDefaultRoutes ? getDefaultRoutes(appConfig) : [];

  const _useLocale = (0, _Locale.useLocale)(),
        locale = _useLocale.locale;

  (0, _react.useEffect)(() => {
    const loadPolyfills = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var i, l;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loadLocalePolyfill(locale);
              i = 0;

            case 2:
              if (!(i < locales.length)) {
                _context.next = 11;
                break;
              }

              l = locales[i];

              if (!(l.locale === locale)) {
                _context.next = 8;
                break;
              }

              if (!l.loadData) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return l.loadData;

            case 8:
              i++;
              _context.next = 2;
              break;

            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));

      return function loadPolyfills() {
        return _ref5.apply(this, arguments);
      };
    }();

    loadPolyfills();
  }, [locale, locales]);
  (0, _react.useEffect)(() => {
    const loadMessages = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var messages;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _locale.getLocaleMessages)(locale, locales);

            case 2:
              messages = _context2.sent;
              setMessages(messages);

            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));

      return function loadMessages() {
        return _ref6.apply(this, arguments);
      };
    }();

    loadMessages();
  }, [locale, locales]);
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale,
    key: locale,
    messages: messages,
    onError: onError
  }, /*#__PURE__*/_react.default.createElement(LayoutContainer, null, Menu && /*#__PURE__*/_react.default.createElement(Menu, null), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(Loading, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, routes.map((Route, i) => {
    return _react.default.cloneElement(Route, {
      key: "@customRoutes/" + i
    });
  }), defaultRoutes.map((Route, i) => {
    return _react.default.cloneElement(Route, {
      key: "@defaultRoutes/" + i
    });
  })))));
};

exports.LayoutContent = LayoutContent;

const Layout = () => {
  const _useConfig2 = (0, _Config.useConfig)(),
        appConfig = _useConfig2.appConfig;

  const _ref7 = appConfig || {},
        locale = _ref7.locale;

  const _ref8 = locale || {},
        defaultLocale = _ref8.defaultLocale,
        persistKey = _ref8.persistKey;

  return /*#__PURE__*/_react.default.createElement(_Provider.default, {
    defaultLocale: defaultLocale,
    persistKey: persistKey
  }, /*#__PURE__*/_react.default.createElement(LayoutContent, {
    appConfig: appConfig
  }));
};

exports.Layout = Layout;
var _default = Layout;
exports.default = _default;